import { render, staticRenderFns } from "./links.vue.html?vue&type=template&id=80c8c2a6"
import script from "./links.controller.ts?vue&type=script&lang=js&external"
export * from "./links.controller.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports